export const layers = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_LAYER': {
      if (action.payload.isCustom) return state;
      return {
        ...state,
        [action.payload.key]: action.payload,
      };
    }
    default:
      return state;
  }
};
